export default __webpack_public_path__ + "static/video-f17a98be79f66e8f493751d49d81cfcf.png";